import { render, staticRenderFns } from "./widgetFwAreaBasedDefenseTraffic.vue?vue&type=template&id=ba93a8a6&scoped=true&"
import script from "./widgetFwAreaBasedDefenseTraffic.vue?vue&type=script&lang=js&"
export * from "./widgetFwAreaBasedDefenseTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba93a8a6",
  null
  
)

export default component.exports